import styled from '@emotion/styled';
import * as Popover from '@radix-ui/react-popover';
import cn from 'classnames';
import { FC, useEffect, useRef, useState } from 'react';
import RenderTip from './components';
import { useTip } from './provider';
import { FdBulb } from '@qodly/icons';

const Trigger = styled(Popover.Trigger)`
  &[data-state='open'] > * {
    display: block !important;
  }
`;

export const Tip: FC<{
  tipKey: string;
  side?: 'left' | 'right';
  alwaysOn?: boolean;
  asButton?: boolean;
}> = ({ tipKey, side = 'right', alwaysOn, asButton = false }) => {
  const { tip, enabled } = useTip(tipKey);
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (triggerRef.current) {
      const triggerObserver = new IntersectionObserver((payload) => {
        if (!payload[0].isIntersecting) {
          setIsOpen(false);
        }
      });
      triggerObserver.observe(triggerRef.current);

      return () => {
        if (triggerRef.current) {
          triggerObserver.unobserve(triggerRef.current);
        }
      };
    }
  }, []);

  if (tip && enabled) {
    return (
      <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
        <Trigger
          ref={triggerRef}
          className={cn('focus:outline-none', {
            'rounded p-1 text-gray-100 hover:bg-primary-hover': asButton,
          })}
          onClick={(e) => e.stopPropagation()}
        >
          <span className={cn('group-hover:block', { hidden: !alwaysOn })}>
            <FdBulb className="h-4 w-4 text-yellow-300" />
          </span>
        </Trigger>
        <Popover.Content
          side={side}
          sideOffset={5}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative rounded border border-grey-50 bg-grey-900 p-2 text-xs text-white shadow-2xl">
            {RenderTip(tip)}
          </div>
        </Popover.Content>
      </Popover.Root>
    );
  }

  return null;
};
